<div class="casino-promo-optin-insta-story" [ngStyle]="{ 'background-color': promostoryBgclr }">
    <div class="casino-promoinstastory-video-mute-button" *ngIf="storyHasVideo">
        <button
            class="toggle-mute-button"
            aria-hidden="true"
            [ngStyle]="{ color: muteunmuteClr }"
            [ngClass]="{ 'theme-sound-loud': !mute, 'theme-sound-mute': mute }"
            (click)="toggleMute($event)"></button>
    </div>
    <video
        class="casino-promoinstastory-video"
        id="casino-promoinstastory-video"
        autoplay
        playsinline
        onloadeddata="this.play();"
        *ngIf="videoUrl"
        [src]="videoUrl"
        [muted]="mute"
        (loadeddata)="videoLoaded()"
        (timeupdate)="timeUpdate()"></video>
    <cloudflare-stream
        id="casino-promoinstastory-cmsvideo"
        preload="auto"
        class="casino-promoinstastory-video"
        *ngIf="cmsVideoUrl"
        [height]="'100%'"
        [controls]="false"
        [src]="cmsVideoUrl"
        [muted]="mute"
        [autoplay]="true"
        (timeupdate)="cmsTimeUpdate()"></cloudflare-stream>
    <div class="div-promo-optin-insta-story"></div>
    <div class="promo-title-container">
        <h1 class="insta-story-title" *ngIf="promoInstaStoryItem.title" [ngStyle]="{ 'color': TitleTxtClr, 'font-size': TitleFontSize }">
            {{ promoInstaStoryItem.title }}
        </h1>
        <h2 class="insta-story-subtitle" *ngIf="promoInstaStoryItem.subTitle" [ngStyle]="{ 'color': SubTitleTxtClr, 'font-size': SubTitleFontSize }">
            {{ promoInstaStoryItem.subTitle }}
        </h2>
        <div class="promo-discrip" *ngIf="promoInstaStoryItem.description" [ngStyle]="{ color: DescriptionClr }">
            {{ promoInstaStoryItem.description }}
        </div>
        <div class="optinBtn" *ngIf="isDisplayCta">
            <a
                class="btn btn-primary more-info-btn"
                *ngIf="isEnableCustomCta && !gameId"
                [ngStyle]="{ 'background-color': OptinBtnBgClr, 'color': OptinBtnTxtClr }"
                [href]="optinCta"
                (click)="optinClick()"
                >{{ ctaText }}</a
            >
            <a
                class="btn btn-primary more-info-btn"
                *ngIf="isEnableCustomCta && gameId"
                [ngStyle]="{ 'background-color': OptinBtnBgClr, 'color': OptinBtnTxtClr }"
                (click)="launchGame()"
                >{{ gamingCtaText }}</a
            >
            <cc-promo-optin-button *ngIf="!isEnableCustomCta" [item]="item"></cc-promo-optin-button>
        </div>
    </div>
    <div class="optin-tncontent" *ngIf="promoInstaStoryItem.tnCContent" [ngStyle]="{ 'background-color': TncBgClr, 'color': TncTxtClr }">
        <span>{{ promoInstaStoryItem.tnCContent }}</span>
    </div>
</div>
